import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Modal } from 'bootstrap'
import { Row, Col, Card, CardBody, Label, Button } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation";
import PropTypes from 'prop-types';
// import jwt from 'jsonwebtoken';
import * as s from "../styles/globalStyles";
import styled from "styled-components";
import "../styles/nft.css";
import { useParams  } from 'react-router-dom';
// Team
import { BsLinkedin, BsGithub } from "react-icons/bs";

import P2P from "../images/EsproPay/p2p.jpeg";
import cover from "../images/EsproPay/cover.jpeg";


import { connectRequest, createUser, loginotpUpdate, getAccountInfo} from "../store/action";
import axios from "axios";

// ROSHAN
const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: "white";
  padding: 10px;
  font-weight: bold;
  color: "black";
  width: 100px;
  cursor: pointer;
  box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 6px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: "white";
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

const NftHomeComponents = (props) => {
  // ROSHAN

  const {token} = useParams();

  const [selectedUsertypeform, setUsertypeform] = useState(null)
  const blockchain = useSelector((state) => state.blockchain);
  const [showBuyButton, setBuyButton] = useState(false);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [showModalMapping, setShowModalMapping] = useState(null);
  const [showOtp, setOtpUpdate] = useState(false);
  const [espro,setEspro] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mint(mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);

       // dispatch(fetchData(blockchain.account));

      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const handleConnectToBlockChain = async (event, values) => {
    props.connectRequest()
  }

const getQuery=()=>{
  console.log('working-query');
console.log(token);
decodeToken(token)

}
  const decodeToken=(token)=> {
    try {
      console.log('decoding',token);
      const secretKey = 'Ggx2q_b5JUj4lah8j7QRATzpoVotsnLLIuHyODA2';
      // const decoded = jwt.verify(token, secretKey,(error,value)=>{
      //   if (error) {
      //     console.log(error);
      //   }
      //   return value;
      // });
      // console.log(decoded);
    } catch (error) {
      console.error(error);
    }
  }

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      let data = {
        accountid: blockchain.account
      }
      props.getAccountInfo(data)
    }
  };

  const getesproExchangeRate = async ()=>{
    const res = await axios.get('api/exchange')
    console.log(res.data);
    setEspro(res.data)
  }

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };
  const addRegistrationModal = useRef();

  useEffect(() => {
    setShowModalMapping(new Modal(addRegistrationModal.current))
    setOtpUpdate(false);
    getConfig();
    // getesproExchangeRate();
    // getQuery();
    // decodeToken();
  }, []);


  useEffect(() => {
    getData();
  }, [blockchain.account])
  

  useEffect(() => {
  
    if(props.auth.authData!=null && props.auth.authData?.isShowOtp){
      setOtpUpdate(true);
    }

    if(props.auth.authData!=null && props.auth.authData?.isreadytobuy){
        setBuyButton(true);
        showModalMapping.hide()
    }

    if(props.auth.authData!=null && props.auth.authData?.showModal){
      showModalMapping.show();
    }

    if(props.auth.registrationError!=null){
      alert('Please check error message logs')
    }

  }, [ props.auth?.authData, props.auth.registrationError]);

  async function  handleUsersType(event, errors, values) {
    // console.log(values);
    if(errors.length == 0 ){
      if(values.email!=null && blockchain.account!=null){

        if(!showOtp){
          let data = {
            username: values.email,
            accountid: blockchain.account
          }
           props.createUser(data);
        }else{
          let data = {
            username: values.email,
            otpnumber: values.otpnumber
          }
          props.loginotpUpdate(data);
        }
      }
    }
  } 




  return (
    <div className="body">
     
             {/* Add User */}
             <div className="modal fade" ref={addRegistrationModal} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Update User Information</h5>
                    <button type="button" className="btn-close" onClick={() => showModalMapping.hide()} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                  <Col xl="12">
                    <Card>
                        <CardBody>
                        <AvForm className="needs-validation" onSubmit={handleUsersType} ref={c => ( setUsertypeform(c))}>
                           
                            <Row>
                            <Col md="12">
                                <div className="mb-3">
                                <Label htmlFor="validationCustom03">Email</Label>
                                <AvField
                                    name="email"
                                    placeholder="Email Address"
                                    type="text"
                                    errorMessage=" Please provide a email address."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom03"
                                />
                                </div>
                            </Col>
                            {
                              (showOtp) ?                             
                              <Col md="12">
                                <div className="mb-3">
                                <Label htmlFor="validationCustom04">Confirmation Code</Label>
                                <AvField
                                    name="otpnumber"
                                    placeholder="Confirmation Code"
                                    type="text"
                                    errorMessage="Please provide a valid Code."
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="validationCustom04"
                                />
                                </div>
                            </Col> : ''
                            }

                
                            </Row>
                  
                            <Row>
                                <Col className="btn-alignment-end">
                                    <button type="button" className="btn btn-secondary me-2" 
                                    onClick={() => showModalMapping.hide()}>Close</button>

                                    <Button className="ml-2" color="primary" type="submit">
                                        Submit
                                    </Button>
                                </Col>
                            </Row>
                        </AvForm>
                        </CardBody>
                    </Card>
                    </Col>
                  </div>
                  {/* <div className="modal-footer">
                    <button type="button" className="btn btn-primary">Continue</button>
                  </div> */}
                </div>
              </div>
            </div>


            <div  className='text-dark mx-5 pb-4'>
    <div  className='text-center my-3 '>
     <img src={cover} className="cover-img" />
    <div className='mt-3 text-center'>
     <h2 className="text-primary">Step 1 - Choose where to send your ESPRO payment</h2>
    <h3>Option 1 - Send directly to this ERC20 Address: </h3>
    <h3>Option 2 - Send directly to this BEP20 Address: </h3>
    </div>
<div className="text-center my-3">
 <h2 className="mt-5 me-3">Don't have ESPRO token? Buy ESPRO token here : </h2> 
 <img src={P2P} className="p2p-img ms-3" />
</div>
    <div className='mt-3 text-center my-4'>
     <h2 className="text-primary">Step 2 - Enter the current Amount</h2>
    <h3>This amount you send is the sller has listed the item for sale if the item 
     is being sold for $100 you send $100
    </h3>
    </div>

    <div>
    <div className="mb-3 row justify-content-center">
 <div className="col-3 d-flex">
 <label htmlFor="Price" className="col-sm-2 ">ESPRO</label>
   <input type="text" className="form-control" id="Price" readOnly value="1"/>
 </div>


 <div className="col-3 d-flex">
 <label htmlFor="inputPassword" className="col-sm-2 ">Price USD</label>
   <input type="number" className="form-control" id="inputPassword" disabled value={espro}/>
 </div>
</div>


<div className="mb-3 mt-3 row justify-content-center">
 <div className="col-3 d-flex">
 <label htmlFor="Price" className="col-sm-2 ">Price USD</label>
   <input type="text" className="form-control" id="Price" readOnly value="1"/>
 </div>


 <div className="col-3 d-flex">
 <label htmlFor="inputPassword" className="col-sm-2 ">ESPRO</label>
   <input type="number" className="form-control" id="inputPassword" disabled value={espro}/>
 </div>
</div>
    </div>
    
    {/* Pay exact amount of ESPRO to the above address. */}

    <div className='mt-3 text-center'>
     <h2 className="text-primary">Step 3 - Complete the Order Form</h2>
    <h3>After you have sent payment Once submitted wait for a middleman agent to activate your code.
    </h3>
    <button className="btn btn-primary" routerlink="espro-order">Next</button>
    </div>

     </div>
</div>


     {/* <form>
      <label>
        Enter amount of BTC:
        <input type="number" [(ngModel)]="amount" name="amount">
      </label>
      <br>
      <label>
        Select currency:
        <select [(ngModel)]="currency" name="currency">
          <option value="USD">USD</option>
          <option value="EUR">EUR</option>
          <option value="GBP">GBP</option>
        </select>
      </label>
    </form> */}
    {/* <div>
      {{ amount }} BTC is equal to {{ conversion }} {{ currency }}.
    </div> */}




 {/* < !--Description Start-- >  */}
      {/* <div className=" text-light">
        <h4 className="my-5 text-center" style={{ fontSize: "25px" }}>
          {" "}
          EsportsPro Championship Club (ESPC)
        </h4>

        <div className=" roww d-flex justify-content-center">
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img1} className="NftImg" />
          </div>
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img2} className="NftImg" />
          </div>
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img3} className="NftImg" />
          </div>
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img5} className="NftImg" />
          </div>
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img4} className="NftImg" />
          </div>
          <div className="col coll" style={{ padding: "0px !important" }}>
            <img src={img6} className="NftImg" />
          </div>
        </div>

        <div
          className="d-flex justify-content-center mt-5"
          style={{ clear: "both" }}
        >
          <p className="Nftpara mb-5 mt-5 text-center">
            Esportspro Championship Club ( ESPC ) have an exquisite collection
            of personalities to cater for Gamers, Influencers, Entrepreneurs,
            Crypto-Traders and Athletes. The collection holders will be entitled
            to participate in the NFT H2H skilled games challenge which gives
            them an opportunity to win more NFTs and subsequently, the ESPC
            holders will also become eligible for a free entry into our ESPRO
            token Prize pools.
          </p>
        </div>
      </div> */}
      {/* < !--Description End-- > */}

      {/* <s.Screen
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          wordWrap: "none",
        }}
      >
        <img src={img1} className="SideImg1" />
        <img src={img2} className="SideImg2" />
        <img src={img3} className="SideImg3" />
        <img src={img4} className="SideImg4" />
        <s.Container
          flex={1}
          ai={"center"}
          image={CONFIG.SHOW_BACKGROUND ? "/config/images/bg.png" : null}
        >
          <s.SpacerSmall />
          <ResponsiveWrapper flex={1} style={{ padding: 24 }} test>
            <s.SpacerLarge />

            <s.Container
              flex={2}
              jc={"center"}
              ai={"center"}
              style={{
                backgroundColor: "var(--accent)",
                padding: 24,
                borderRadius: 24,
                border: "4px dashed var(--secondary)",
                boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
              }}
            >
              <s.TextTitle
                style={{
                  textAlign: "center",
                  fontSize: 50,
                  fontWeight: "bold",
                  color: "var(--accent-text)",
                }}
              >
                {data.totalSupply} / {CONFIG.MAX_SUPPLY}
              </s.TextTitle>
              <s.TextDescription
                style={{
                  textAlign: "center",
                  color: "var(--primary-text)",
                }}
              >
                <StyledLink
                  style={{ color: "white" }}
                  target={"_blank"}
                  href={CONFIG.SCAN_LINK}
                >
                  {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
                </StyledLink>
              </s.TextDescription>
              <s.SpacerSmall />
              <div>
                {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
                  <>
                    <s.TextTitle
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      The sale has ended.
                    </s.TextTitle>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      You can still find {CONFIG.NFT_NAME} on
                    </s.TextDescription>
                    <s.SpacerSmall />
                    <StyledLink
                      style={{ color: "white" }}
                      target={"_blank"}
                      href={CONFIG.MARKETPLACE_LINK}
                    >
                      {CONFIG.MARKETPLACE}
                    </StyledLink>
                  </>
                ) : (
                  <>
                    <s.TextTitle
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      1 {CONFIG.SYMBOL} costs {CONFIG.DISPLAY_COST}{" "}
                      {CONFIG.NETWORK.SYMBOL}.
                    </s.TextTitle>
                    <s.SpacerXSmall />
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Excluding gas fees.
                    </s.TextDescription>
                    <s.SpacerSmall /> */}
                    {/* {(!showBuyButton || (blockchain.account === "" || blockchain.smartContract === null) ) ? (
                      <s.Container ai={"center"} jc={"center"}>
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          Please switch your network to Polygon (MATIC)
                        </s.TextDescription>
                        <s.SpacerSmall />
                        <StyledButton
                          onClick={(e, v) => {
                            handleConnectToBlockChain(e, v)
                          }}
                        >
                          CONNECT
                        </StyledButton>
                        {blockchain.errorMsg !== "" ? (
                          <>
                            <s.SpacerSmall />
                            <s.TextDescription
                              style={{
                                textAlign: "center",
                                color: "var(--accent-text)",
                              }}
                            >
                              {blockchain.errorMsg}
                            </s.TextDescription>
                          </>
                        ) : null}
                      </s.Container>
                    ) : (
                      <>
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {feedback}
                        </s.TextDescription>
                        <s.SpacerMedium />
                        <s.Container ai={"center"} jc={"center"} fd={"row"}>
                          <StyledRoundButton
                            style={{ lineHeight: 0.4 }}
                            disabled={claimingNft ? 1 : 0}
                            onClick={(e) => {
                              e.preventDefault();
                              decrementMintAmount();
                            }}
                          >
                            -
                          </StyledRoundButton>
                          <s.SpacerMedium />
                          <s.TextDescription
                            style={{
                              textAlign: "center",
                              color: "var(--accent-text)",
                            }}
                          >
                            {mintAmount}
                          </s.TextDescription>
                          <s.SpacerMedium />
                          <StyledRoundButton
                            disabled={claimingNft ? 1 : 0}
                            onClick={(e) => {
                              e.preventDefault();
                              incrementMintAmount();
                            }}
                          >
                            +
                          </StyledRoundButton>
                        </s.Container>
                        <s.SpacerSmall />
                        <s.Container ai={"center"} jc={"center"} fd={"row"}>
                          <StyledButton
                            disabled={claimingNft ? 1 : 0}
                            onClick={(e) => {
                              e.preventDefault();
                              claimNFTs();
                              getData();
                            }}
                          >
                            {claimingNft ? "BUSY" : "BUY"}
                          </StyledButton>
                        </s.Container>
                      </>
                    )}

                  </>
                )}
              </div>
              <s.SpacerMedium />
            </s.Container>
            <s.SpacerLarge />
          </ResponsiveWrapper>
          <s.SpacerMedium />
        </s.Container>
      </s.Screen> */}

      {/* <div className="container Margin"> */}
        {/* <div className="row d-flex justify-content-center mb-3">
          <div className="col-lg-6 d-flex justify-content-center">
            <div className="text-light ">
              <div
                className="card mb-3 NftBackground"
                style={{ maxWidth: "520px", margin: "20px !important" }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={Athletes}
                      className="img-fluid  AngleImg"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body nftCard">
                      <h5 className="card-title text-center mt-2 mb-3">
                        EsportsPro Championship Club Athletes
                      </h5>
                      <p className="card-text text-center px-2 mb-2 align-middle">
                        Who are intrinsically motivated and their Energy, Spirit
                        and Ambition is set for ultimate purpose. Eyeing for
                        Glory, who constantly push their limits to better their
                        past records.
                      </p>
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </div> */}
          {/* <div className="col-lg-6 d-flex justify-content-center margin">
            <div className="text-light ">
              <div
                className="card mb-3 NftBackground"
                style={{ maxWidth: "520px", margin: "20px !important" }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={Gamers}
                      className="img-fluid  AngleImg"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body nftCard">
                      <h5 className="card-title text-center mt-2 mb-3">
                        EsportsPro Championship Club Gamers
                      </h5>
                      <p className="card-text text-center px-2 mb-2 align-middle">
                        Who sets the internet alive with an insatiable appetite
                        to improve their skills and strategic qualities which
                        plays a pivotal role in nurturing the fightback attitude
                        in the real world.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        {/* </div> */}

        {/* <div className="row d-flex justify-content-center mb-3">
          <div className="col-lg-6 d-flex justify-content-center margin">
            <div className="text-light ">
              <div
                className="card mb-3 NftBackground"
                style={{ maxWidth: "520px", margin: "20px !important" }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={Influencers}
                      className="img-fluid  AngleImg"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body nftCard">
                      <h5 className="card-title text-center mt-2 mb-3">
                        EsportsPro Championship Club Influencers
                      </h5>
                      <p className="card-text text-center px-2 mb-2 align-middle">
                        Who always tend to strike the right cord in converging
                        all ranges of audiences and keeping them updated on good
                        aspects of the gaming industry such as profiles to NFTs
                        from marketplace to crowdfunding.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-center margin">
            <div className="text-light ">
              <div
                className="card mb-3 NftBackground"
                style={{ maxWidth: "520px", margin: "20px !important" }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={Entrepreneurs}
                      className="img-fluid  AngleImg"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body nftCard">
                      <h5 className="card-title text-center mt-2 mb-3">
                        EsportsPro Championship Club Entrepreneurs
                      </h5>
                      <p className="card-text text-center px-2 mb-2 align-middle">
                        Who are the contemporary “Dreamers and Makers” . Their
                        propensity to work on daring projects to drive results
                        which are never thought off before to provide
                        exhilarating and congenial features to their
                        users/followers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="row d-flex justify-content-center mb-3">
          <div className="col-lg-6 d-flex justify-content-center margin">
            <div className="text-light ">
              <div
                className="card mb-3 NftBackground"
                style={{ maxWidth: "520px", margin: "20px !important" }}
              >
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src={Hodlers}
                      className="img-fluid  AngleImg"
                      alt="..."
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body nftCard">
                      <h5 className="card-title text-center mt-2 mb-3">
                        EsportsPro Championship Club Hodlers
                      </h5>
                      <p className="card-text text-center px-2 mb-2">
                        Who are the modern day samurais whose risk appetite is
                        beyond anyone’s imagination. Their fearless investing
                        approach keeps the markets exciting and pulsating. Many
                        dream to be one of them however, very few seem to master
                        it.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Road map Start*/}
        {/* <div className="text-light">
          <h1 className="text-center mt-3 mb-4" style={{ fontSize: "25px" }}>
            Road Map
          </h1>

          <div style={{ position: "relative" }}>
            <div className="row d-flex  justify-content-start">
              <div className="col-6 PhoneWidth ">
                <div className="TriangleRight mt-2 py-3">
                  <div className="Round"></div>
                  <h2 className="mb-2 ">Private Sale (500 NFTs)</h2>
                  <p className="align-middle mt-3">
                    Welcome Challengers! Our private sale starts at 30 MATIC and
                    you are now officially enlisted as a founding supporter of
                    the EsportsPro Championship Club. You stand at the start of
                    something significant. Your mysterious NFTs are ready to
                    take you places you cannot imagine.
                  </p>
                </div>
              </div>
            </div>

            <div className="row d-flex  justify-content-end">
              <div className="col-6  PhoneWidth">
                <div className=" TriangleLeft mt-5 py-3">
                  <div className="Round2"></div>
                  <h2 className="mb-2">
                    Airdrop for the 100 private sale participants
                  </h2>
                  <p className="align-middle mt-3">
                    The first 500 NFT holders will be eligible to receive
                    Airdrop to100 Wallet addresses which gives them an exclusive
                    opportunity to challenge more games with great fun. The
                    private sale of NFTs will be revealed at Opensea.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6 PhoneWidth ">
                <div className="TriangleRight mt-5 py-3">
                  <div className="Round"></div>
                  <h2 className="mb-2">Public Sale</h2>
                  <p className="align-middle mt-3">
                    The public sale starts at 50 MATIC. Public sale begins after
                    the conclusion of private sale. We expect all enthusiastic
                    gamers and NFT holders to use the private sale offer to
                    indulge in challenging more games to win more NFTs.
                  </p>
                </div>
              </div>
            </div>

            <div className="row d-flex  justify-content-end">
              <div className="col-6 PhoneWidth">
                <div className=" TriangleLeft mt-5 py-3">
                  <div className="Round2"></div>
                  <h2 className="mb-2">NFT Challenges for skill games</h2>
                  <p className="align-middle mt-3">
                    Skill games will be released and our ESPC holders will be
                    able to invite Head 2 Head NFT challenges to win more
                    engrossing NFTs. Early adoption games will be online Board
                    game and 8 Ball pool game and along the road map we will
                    adopt more skill games.
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-6 PhoneWidth  ">
                <div className="TriangleRight  mt-5 py-3">
                  <div className="Round"></div>
                  <h2 className="mb-2 ">
                    ESPRO Token Prize money, Free Entry challenges for ESPC NFT
                    holders
                  </h2>
                  <p className="align-middle mt-3">
                    The 1,000,000 ESPRO tokens prize pool will be distributed to
                    ESPC NFT holders who will have the advantage of free entry
                    to Head 2 Head games and win ESPRO tokens.
                  </p>
                </div>
              </div>
            </div>
            <div className="verticalLine"></div>
            <div className="row d-flex  justify-content-end">
              <div className="col-6 PhoneWidth">
                <div className=" TriangleLeft mt-5 py-3 ">
                  <div className="Round2"></div>
                  <h2 className="mb-2  ddd">
                    Partnership with other NFT projects
                  </h2>
                  <p className="align-middle mt-3">
                    We believe these Head 2 Head challenges will be welcomed by
                    NFT projects across the range. who would be very interested
                    to offer giveaways for skill game challenges. Which we will
                    customize according to our partnership requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Road map End*/}

        {/* Video Start*/}
        {/* <div className="text-center mt-5 text-light">
          <h4 className="my-4" style={{ fontSize: "25px" }}>
            EsportsPro Championship Club NFT challenges for skills and board
            games
          </h4>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/schHwpX28UQ"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div> */}

        {/* Video2 Start*/}
        {/* <div className="text-center mt-5 text-light">
          <h4 className="my-4" style={{ fontSize: "25px" }}>
            Add Polygon MATIC network to Metamask and Mint ESPC NFTs
          </h4>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/LsSc4ZeYyMY"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div> */}
        {/* Video End*/}
      {/* </div> */}
      {/* Team Start*/}
      {/* <div className=" text-light text-center">
        <h4 className="my-4 " style={{ fontSize: "25px" }}>
          {" "}
          Meet The Team{" "}
        </h4>
        <div className=" row d-flex justify-content-center">
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={sandeep} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Creative Director - Sandeep
                </h5>
                <a
                  href="https://www.linkedin.com/in/sandeep-kumar-1a2583229/"
                  target="_blank"
                  className="btn mt-3"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Alisha} className="card-img-top" alt="..." />
              <div className="card-body ">
                <h5 className="card-title title-height">
                  Business Development Manager - Alisha
                </h5>
                <a
                  href=" https://www.linkedin.com/in/alisha-das-950425226/"
                  className="btn mt-3"
                  target="_blank"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Jayson} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Community Manager - Jayson Roy
                </h5>
                <a
                  href=" https://www.linkedin.com/search/results/all/?keywords=jayson%20roy&origin=RICH_QUERY_TYPEAHEAD_HISTORY&position=0&searchId=a360ebeb-9bd2-4fe1-b7a0-f277e642d0bc&sid=J)M"
                  className="btn mt-3"
                  target="_blank"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Raza} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Blockchain Development - Muhammad Adil Raza
                </h5>
                <a
                  href="https://github.com/madilraza"
                  target="_blank"
                  className="btn mb-2 bg-primary btnPadding"
                >
                  <BsGithub
                    style={{
                      backgroundColor: "#fff",
                      color: "#000",
                      fontSize: "2em",
                      borderRadius: "16px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Kajan} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Technical Lead - Kajanthan
                </h5>
                <a
                  href="https://www.linkedin.com/in/kajanthankathirgamanathan"
                  target="_blank"
                  className="btn mt-3"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Kajen} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Operation - Kajenthran
                </h5>
                <a
                  href="https://www.linkedin.com/in/kajeni24/"
                  target="_blank"
                  className="btn mt-3"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Ros} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Fullstack Developer - Roshanthan
                </h5>
                <a
                  href="https://www.linkedin.com/in/anne-roshanthan-05113a210/"
                  target="_blank" rel="noreferrer"
                  className="btn mt-3"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="col coll mt-3">
            <div
              className="card"
              style={{
                width: "18rem",
                backgroundColor: "#000",
                border: "1px solid",
              }}
            >
              <img src={Kish} className="card-img-top" alt="..." />
              <div className="card-body">
                <h5 className="card-title title-height">
                  Frontend Design - Kishanth
                </h5>
                <a
                  href="https://www.linkedin.com/in/arulselvan-kishanth-110134203"
                  target="_blank"
                  className="btn mt-3"
                >
                  <BsLinkedin
                    style={{
                      backgroundColor: "#fff",
                      color: "blue",
                      fontSize: "2em",
                      borderRadius: "4px",
                    }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* Team End*/}

      {/* partners Start */}
      {/* <div className="d-flex justify-content-center mb-5">
        <div className="partners-container text-light text-center">
          <h4 className="my-4 mt-5" style={{ fontSize: "25px" }}>
            {" "}
            Our Partners{" "}
          </h4>
          <div className=" row d-flex justify-content-center">
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://coinmarketcap.com/currencies/esportspro/"
                  target="_blank"
                >
                  <img
                    src={coinmarketcap}
                    className="card-img-top partner-img"
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://app.dodoex.io/exchange/MATIC-ESPRO?network=polygon"
                  target="_blank"
                >
                  <img
                    src={dodo}
                    className="card-img-top partner-img"
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://nftcalendar.io/event/esportspros-nft-trophies/"
                  target="_blank"
                >
                  <img
                    src={nft}
                    className="card-img-top partner-img"
                    style={{ objectFit: "fill", objectPosition: "0px" }}
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a href="https://p2pb2b.io/trade/ESPRO_USDT/" target="_blank">
                  <img
                    src={p2p}
                    className="card-img-top partner-img"
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://info.quickswap.exchange/#/pair/0x9bb8d1be5b3ebae869172d5252ee46c343e09d55"
                  target="_blank"
                >
                  <img
                    src={quickswap}
                    className="card-img-top partner-img"
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://nftdesire.io/upcoming-nft-projects/esportspro-championship-club-espc/"
                  target="_blank"
                >
                  <img
                    src={NFTDesire}
                    className="card-img-top partner-img"
                    style={{ objectFit: "contain" }}
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a
                  href="https://nftexpress.vote/nft/1566/EsportsPro-Championship-Club/"
                  target="_blank"
                >
                  <img
                    src={express}
                    className="card-img-top partner-img"
                    style={{ objectFit: "contain" }}
                    alt="..."
                  />
                </a>
              </div>
            </div>
            <div className="col coll mt-3">
              <div className="">
                <a href="https://nextdrop.is/project/6173" target="_blank">
                  <img
                    src={next}
                    className="card-img-top partner-img"
                    style={{ objectFit: "contain" }}
                    alt="..."
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* partners End */}
    </div>
  );
}

const mapStateToProps = state => {
  const { blockchain, auth} = state
  return { blockchain, auth }
}

export default connect(mapStateToProps, { connectRequest, createUser, loginotpUpdate, getAccountInfo })(NftHomeComponents)


NftHomeComponents.propTypes = {
  errorMsg: PropTypes.any,
  account: PropTypes.any,
  history: PropTypes.object,
  connectRequest: PropTypes.func,
  createUser: PropTypes.func,
  loginotpUpdate: PropTypes.func,
  getAccountInfo: PropTypes.func
}